// @flow

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { dateTime, time } from '../Shared/timeutils'
import DateTimeFilter from '../Shared/Buttons/DateTimeFilter'
import CustomFilter from '../Shared/Buttons/CustomFilter'
import ContentList from '../Shared/Data/ContentList'
import ActivityList from '../Shared/Data/ActivityList'
import ProfileOrGroupList from '../Shared/Data/ProfileOrGroupList'
import SearchWordCloud from '../Shared/Data/SearchWordCloud'
import { fetchUserDetails } from '../Redux/Actions/Details'
import BackArrow from '../Shared/Icons/icon-backarrow-grey.svg'
import './UserDetails.css'
import './Wrappers.css'
import { componentCreated, updateDateFilter } from '../Redux/Actions/DateFilter'
import { useLocation, useNavigate } from 'react-router'
import { composeFilterString, getDateFilter, getGroupFilter, processDate, processGroup } from '../utils/analytics-utils'
import { addQuery } from '../utils/router-utils'

function UserDetails () {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const id = useSelector(state => state.account.ID)
  const data = useSelector(state => state.details.user)
  const dateFilterStore = useSelector(state => state.dateFilter)
  const name = 'UserDetails'

  let dateFilterFromStore = getDateFilter(dateFilterStore, name)
  dateFilterFromStore = dateFilterFromStore ? dateFilterFromStore.dateFilter || 'Week' : 'Week'
  const [dateFilter, setDateFilter] = useState(dateFilterFromStore)

  const groupFilter = getGroupFilter(dateFilterStore, name) || ''
  const dateInterval = dateFilter ? dateFilter.dateInterval || null : null

  useEffect(() => {
    dispatch(componentCreated(name))
  }, [])

  useEffect(() => {
    if (id) {
      update(processDate(dateFilter, id), processGroup(groupFilter), id)
    }
  }, [])

  useEffect(() => {
    newQuery(location.search.substring(1).split('&'))
  }, [])

  const newQuery = (query) => {
    const qobj = {}
    let newDateFilter
    query.forEach((q) => {
      qobj[q.split('=')[0]] = q.split('=')[1]
    })
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }
    update(processDate(newDateFilter), processGroup(groupFilter), id)
  }

  const update = (date, group, newID) => {
    const ID = newID || id
    const searchQ = location.search.substring(1).split('&')
    searchQ.forEach((q) => {
      searchQ[q.split('=')[0]] = q.split('=')[1]
    })
    // const startUtc = Date.UTC(date.start.getFullYear(), date.start.getMonth(), date.start.getDate() + 1)
    // const endUtc = Date.UTC(date.end.getFullYear(), date.end.getMonth(), date.end.getDate() + 1)
    // dispatch(fetchUserDetails(ID, new Date(startUtc).toISOString(), new Date(endUtc).toISOString(), searchQ.id))
    dispatch(fetchUserDetails(ID, date.start.toISOString(), date.end.toISOString(), searchQ.id))
  }

  const changeDateFilter = (newFilter, isCustom) => {
    if (isCustom) {
      dispatch(updateDateFilter(name, 'Custom', newFilter))
    } else {
      dispatch(updateDateFilter(name, newFilter))
    }
    const f = `${composeFilterString(groupFilter.profiles, groupFilter.groups)}_${groupFilter.alt || ''}`
    addQuery({ date: newFilter, filter: f }, location, navigate)
    setDateFilter(newFilter)
    if (newFilter !== 'Custom') {
      update(processDate(newFilter), processGroup(groupFilter))
    }
  }

  if (data.title && data.title === 'Loading') {
    return (
      <div>
        <div className='toolbar'>
          <div>
            <h2>
              <div className='button-cursor' onClick={() => navigate(-1)}>
                <img src={BackArrow} className='interactive' alt='back' />
                Loading
              </div>
            </h2>
          </div>
          <DateTimeFilter filterBy={changeDateFilter} currentFilter={dateFilter} />
          <div />
        </div>
        <div className='UserContent ContentContainer' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
            <div style={{
              width: '30px',
              height: '30px',
              border: '4px solid #ccc',
              borderTop: '4px solid #3498db',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }} />
          </>
        </div>
      </div>
    )
  }
  return (
    <div>
      <div className='toolbar'>
        <div>
          <h2>
            <div className='button-cursor' onClick={() => navigate(-1)}>
              <img src={BackArrow} className='interactive' alt='back' />
              {data.user.name}
            </div>
          </h2>
        </div>
        <DateTimeFilter filterBy={changeDateFilter} currentFilter={dateFilter} />
        <div />
      </div>
      {(dateFilter !== 'Day' && dateFilter !== 'Week' && dateFilter !== 'Month') ? <CustomFilter filterBy={changeDateFilter} currentFilter={dateFilter} /> : ''}
      <div className='UserContent ContentContainer'>
        <div className='col1'>
          <ActivityList data={data.recentActivity} />
          <div className='box'><h4>{dateTime(data.lastLogin)}<span className='pushRight'>LAST LOGIN</span></h4></div>
          <div className='box'><h4>{time(data.avgDurationInApp)}<span className='pushRight'> AVERAGE DURATION IN MOBILE</span></h4></div>
          <div className='box'><h4>{time(data.avgDurationInCMS)}<span className='pushRight'> AVERAGE DURATION IN WEB</span></h4></div>
          <SearchWordCloud data={data.topSearches} />
        </div>
        <div className='col2'>
          <ContentList
            groupFilter={processGroup(groupFilter)}
            data={data.recentViews}
            type='ViewsDuration'
            alt='IndUserView'
            title='Last Content Viewed'
          />
          <ProfileOrGroupList title={`${data.user.name}'s Profiles`} data={data.profileNames} />
          <ProfileOrGroupList title={`${data.user.name}'s Groups`} data={data.groupNames} />
        </div>
      </div>
    </div>
  )
}

export default UserDetails
